module.exports = __webpack_public_path__ + "img/safe.53e2f4da.svg";